/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

//ran this thru claudes code refactoring tool

// suggested improvements for this component
// give me the entire code to copy

// redesign this component to look more elegant and polished and accents
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy


import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { get_customer_order_details } from '../../store/reducers/orderReducer';
import { get_event_details } from '../../store/reducers/eventDetailsReducer';

import Moment from 'moment';
import { currencyFormat } from '../CurrencyFormat';
import GetSellerConfig from '../GetSellerConfig';

import config from '../../config';

// ─── Info Card ────────────────────────────────────────────────────────────────
const InfoCard = ({ label, children, colorDark, colorMedium, colorLight, hidden = false }) => {
    if (hidden) return null;
    return (
        <div className='relative rounded-xl h-fit bg-white'>
            <div
                className='relative rounded-xl p-4 flex flex-col gap-1 border transition-shadow 
                duration-200'
                style={{
                    backgroundColor: colorLight,
                    borderColor: colorDark,
                    borderLeftWidth: '5px',
                    borderLeftColor: colorDark,
                }}>
                {label && (
                    <span
                        className='text-[10px] font-semibold uppercase tracking-widest mb-1'
                        style={{ color: colorDark }}>
                        {label}
                    </span>
                )}
                <div className='text-[13px] font-medium leading-relaxed'
                    style={{ color: colorDark }}>
                    {children}
                </div>
            </div>
        </div>
    );
};

// ─── Status Badge ─────────────────────────────────────────────────────────────
const StatusBadge = ({ value }) => {
    const isPaid = value === 'paid';
    return (
        <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-semibold tracking-wide ${
                isPaid
                    ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'
                    : 'bg-rose-50 text-rose-700 ring-1 ring-rose-200'
            }`}>
            <span className={`w-1.5 h-1.5 rounded-full ${isPaid ? 'bg-emerald-500' : 'bg-rose-500'}`} />
            {value}
        </span>
    );
};

// ─── Section Heading ──────────────────────────────────────────────────────────
const SectionHeading = ({ children, colorDark }) => (
    <div className='flex items-center gap-3 py-3'>
        <span
            className='text-[12px] font-bold uppercase tracking-[0.18em]'
            style={{ color: colorDark }}>
            {children}
        </span>
        <div className='flex-1 h-px' style={{ backgroundColor: colorDark }} />
    </div>
);

// ─── Product Card ─────────────────────────────────────────────────────────────
const ProductCard = ({ p, colorDark, colorMedium, colorLight, showPayments, showQuantities, sellerBoolShowBrand }) => (
    <div className='rounded-xl bg-white'>
        <div
            className='group flex items-start gap-3 bg-white rounded-xl p-3 border transition-all 
            duration-200 hover:-translate-y-0.5'
            style={{ 
                backgroundColor: colorLight,
                borderColor: colorDark,
                borderLeftWidth: '5px',
                borderLeftColor: colorDark,
            }}>
            {/* Image */}
            {p.name !== 'Deposit' && p.images?.[0] && (
                <div className='shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-gray-50 ring-1 ring-black/5'>
                    <img
                        className='w-full h-full object-cover transition-transform duration-300 group-hover:scale-105'
                        src={p.images[0]}
                        alt={p.name}
                    />
                </div>
            )}

            {/* Details */}
            <div className='flex flex-col gap-0.5 min-w-0'>
                <span className='text-[13px] font-semibold leading-tight truncate'
                    style={{ color: colorDark }}>
                    {p.name}
                </span>
                <span
                    className='text-[11px] font-medium uppercase tracking-wide'
                    style={{ color: colorDark }}>
                    {p.category}
                </span>

                {p.byThePan && p.byThePan !== 'NoPan' && (
                    <span className='text-[11px]' style={{ color: colorDark }}>{p.byThePan}</span>
                )}

                {showPayments && (
                    <span className='text-[13px] font-bold mt-1' style={{ color: colorDark }}>
                        {currencyFormat.format(p.price - Math.floor((p.price * p.discount) / 100))}
                    </span>
                )}

                {p.name !== 'Deposit' && (
                    <div className='flex flex-wrap gap-x-3 gap-y-0.5 mt-1' style={{ color: colorDark }}>
                        {sellerBoolShowBrand && p.brand && (
                            <span className='text-[12px]'>Brand: <span className=''>{p.brand}</span></span>
                        )}
                        {showQuantities && (
                            <span className='text-[12px]'>Qty: <span className='font-semibold'>{p.quantity}</span></span>
                        )}
                        {p.portionSize && (
                            <span className='text-[12px]'>Portion: <span className=''>{p.portionSize}</span></span>
                        )}
                    </div>
                )}
            </div>
        </div>
    </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const OrderDetails = () => {
    const sellerBoolShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;

    const { userInfo } = useSelector(state => state.auth);
    const { myOrder } = useSelector(state => state.order);
    const { eventDetails } = useSelector(state => state.eventDetails);
    const { seller } = useSelector(state => state.seller);

    const {
        sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight,
        sellerColorSuffixMedium, sellerComponentBackgroundColor, sellerProductPluralTerm,
    } = GetSellerConfig();

    const { orderId } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (userInfo?.id) dispatch(get_event_details(userInfo.id));
    }, [userInfo?.id]);

    useEffect(() => {
        if (orderId) dispatch(get_customer_order_details(orderId));
    }, [orderId]);

    const { showPayments, showQuantities } = useMemo(() => {
        let showPayments = seller.isVisibleSitePayments === 'Show';
        let showQuantities = seller.isVisibleSiteProductQuantities === 'Show';
        const hasPackage =
            userInfo &&
            eventDetails &&
            myOrder.eventDetailsInfo?.selectedSellerPackage &&
            myOrder.eventDetailsInfo.selectedSellerPackage !== 'None';
        if (hasPackage) { showPayments = false; showQuantities = false; }
        return { showPayments, showQuantities };
    }, [
        seller.isVisibleSitePayments,
        seller.isVisibleSiteProductQuantities,
        userInfo,
        eventDetails,
        myOrder.eventDetailsInfo?.selectedSellerPackage,
    ]);

    const colorDark   = sellerPrimaryColor1 + sellerColorSuffixDark;
    const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
    const colorLight  = sellerPrimaryColor1 + sellerColorSuffixLight;
    const colorBg     = sellerComponentBackgroundColor || '#f8f9fb';

    const eventInfo      = myOrder.eventDetailsInfo ?? {};
    const isEventDateValid = Moment(eventInfo.eventDate).isValid();

    const sortedProducts = useMemo(() => {
        return [...(myOrder.products ?? [])].sort((a, b) => {
            if (a.category !== b.category) return a.category < b.category ? -1 : 1;
            if (a.name !== b.name) return a.name < b.name ? -1 : 1;
            return 0;
        });
    }, [myOrder.products]);

    return (
        <div className='bg-white rounded-2xl'>
            <div
                className='rounded-2xl overflow-hidden border'
                style={{ 
                    borderColor: colorDark,
                    backgroundColor: colorLight, 
                }}>
                {/* ── Top accent bar style={{ backgroundColor: colorBg }} ── */}
                <div className='hidden h-1 w-full' style={{ backgroundColor: colorDark }} />

                <div className='p-5 md:p-6 space-y-5'>

                    {/* ── Header ── */}
                    <div
                        className='flex flex-wrap items-center justify-between gap-3 pb-4 border-b'
                        style={{ borderColor: colorDark}}>
                        <div>
                            <p className='text-[12px] font-semibold uppercase tracking-widest mb-0.5' 
                                style={{ color: colorDark}}>
                                Order Details
                            </p>
                            <h2 className='text-xl font-bold leading-tight'
                                style={{ color: colorDark}}>
                                {Moment(myOrder.date).format('MMM DD, YYYY')}
                                <span className='font-normal text-sm ml-1'
                                    style={{ color: colorDark }}>
                                    · {Moment(myOrder.date).format('h:mm a')}
                                </span>
                            </h2>
                        </div>
                        <div className='bg-white'>
                            <div
                                className='flex items-center gap-2 px-3 py-1.5 border rounded-full text-[12px] font-semibold ring-1'
                                style={{
                                    color: colorDark,
                                    backgroundColor: colorLight,
                                    ringColor: colorDark,
                                    borderColor: colorDark,
                                }}>
                                <span
                                    className='w-2 h-2 rounded-full'
                                    style={{ backgroundColor: colorDark }}
                                />
                                {myOrder.orderType}
                            </div>
                        </div>
                    </div>

                    {/* ── Event Info ── */}
                    <div>
                        <SectionHeading colorDark={colorDark}>Event Information</SectionHeading>
                        <div className='grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-3'>

                            <InfoCard label='Event Name' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <div className='font-semibold' style={{ color: colorDark }}>
                                    {eventInfo.eventName}
                                </div>
                                {eventInfo.selectedSellerPackage && eventInfo.selectedSellerPackage !== 'None' && (
                                    <div className='mt-1'>
                                        <span className='text-[12px] uppercase tracking-wide' style={{ color: colorMedium }}>
                                            Selected Package 
                                        </span>
                                        <span className='font-semibold' style={{ color: colorDark }}>
                                            {eventInfo.selectedSellerPackage}
                                        </span>
                                    </div>
                                )}
                                <div className='mt-1'>
                                    <span
                                        className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${
                                            eventInfo.depositGiven
                                                ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'
                                                : 'bg-amber-50 text-amber-700 ring-1 ring-amber-200'
                                        }`}>
                                        {eventInfo.depositGiven ? 'Deposit Given' : 'No Deposit'}
                                    </span>
                                </div>
                            </InfoCard>

                            <InfoCard label='Venue' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <div className='font-semibold' style={{ color: colorDark }}>
                                    {eventInfo.venueName}
                                </div>
                                <div className='text-[12px]' style={{ color: colorMedium }}>
                                    {eventInfo.venueAddress}
                                </div>
                            </InfoCard>

                            <InfoCard label='Event Type & Guests' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <div>
                                    <span className='text-[12px]' style={{ color: colorMedium }}>
                                        Event Type: 
                                    </span>
                                    <span className='font-semibold' style={{ color: colorDark }}>
                                        {eventInfo.eventType}
                                    </span>
                                </div>
                                <div>
                                    <span className='text-gray-400 text-[12px]' style={{ color: colorMedium }}>
                                        Number of Guests: 
                                    </span>
                                    <span className='font-semibold' style={{ color: colorDark }}>
                                        {eventInfo.eventGuestCount}
                                    </span>
                                </div>
                            </InfoCard>

                            {isEventDateValid && (
                                <InfoCard label='Date & Time' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                    <div className='font-semibold text-gray-800' style={{ color: colorDark }}>
                                        {Moment(`${eventInfo.eventDate} ${eventInfo.eventStartTime}`).format('ddd, MMM DD, YYYY')}
                                    </div>
                                    <div className='text-gray-500 text-[12px]' style={{ color: colorDark }}>
                                        {Moment(`${eventInfo.eventDate} ${eventInfo.eventStartTime}`).format('h:mm A')}
                                    </div>
                                </InfoCard>
                            )}

                            <InfoCard label='Service & Settings' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <div>
                                    <span className='text-[12px]' style={{ color: colorMedium }}>
                                        Service: 
                                    </span>
                                    <span className='font-semibold' style={{ color: colorDark }}>
                                        {eventInfo.eventServiceType}
                                    </span>
                                </div>
                                <div>
                                    <span className='text-[12px]' style={{ color: colorMedium }}>
                                        Place Settings: 
                                    </span>
                                    <span className='font-semibold' style={{ color: colorDark }}>
                                        {eventInfo.eventPlaceSettings}
                                    </span>
                                </div>
                            </InfoCard>

                            <InfoCard label='Linens' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <div>
                                    <span className='text-[12px]' style={{ color: colorMedium }}>
                                        Tablecloth: 
                                    </span>
                                    <span className='font-semibold' style={{ color: colorDark }}>
                                        {eventInfo.eventGuestTableclothColor}
                                    </span>
                                </div>
                                <div>
                                    <span className='text-[12px]' style={{ color: colorMedium }}>
                                        Napkin: 
                                    </span>
                                    <span className='font-semibold' style={{ color: colorDark }}>
                                        {eventInfo.eventNapkinColor}
                                    </span>
                                </div>
                            </InfoCard>

                            <InfoCard label='Manager Contact' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <div className='' style={{ color: colorDark }}>
                                    {eventInfo.venueManagerContactInfo}
                                </div>
                            </InfoCard>

                            {eventInfo.eventNotes && (
                                <InfoCard label='Notes' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                    <div className='text-[12px] leading-relaxed italic' style={{ color: colorDark }}>
                                        {eventInfo.eventNotes}
                                    </div>
                                </InfoCard>
                            )}

                            {showPayments && (
                                <InfoCard label='Order Total' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                    <div className='text-lg font-bold' style={{ color: colorDark }}>
                                        {currencyFormat.format(myOrder.price)}
                                    </div>
                                </InfoCard>
                            )}

                            {showPayments && (
                                <InfoCard label='Payment Status' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                    <StatusBadge value={myOrder.payment_status} />
                                </InfoCard>
                            )}

                            <InfoCard label='Order Status' colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}>
                                <StatusBadge value={myOrder.delivery_status} />
                            </InfoCard>

                        </div>
                    </div>

                    {/* ── Products Section ── */}
                    <div>
                        <SectionHeading colorDark={colorDark}>
                            {sortedProducts.length} Ordered {sellerProductPluralTerm}
                            <span className='ml-2 font-normal normal-case tracking-normal text-[12px]'
                                style={{ color: colorMedium }}>
                                sorted by category, name
                            </span>
                        </SectionHeading>

                        <div className='grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-3'>
                            {sortedProducts.map((p) => (
                                <ProductCard
                                    key={`${p.category}-${p.name}-${p._id ?? p.id}`}
                                    p={p}
                                    colorDark={colorDark}
                                    colorMedium={colorMedium}
                                    colorLight={colorLight}
                                    showPayments={showPayments}
                                    showQuantities={showQuantities}
                                    sellerBoolShowBrand={sellerBoolShowBrand}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* ── Bottom accent bar ── */}
                <div className='hidden h-0.5 mb-2 w-full' style={{ backgroundColor: colorDark }} />
            </div>
        </div>
    );
};

export default OrderDetails;




//refactored
// import React, { useEffect, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useParams } from 'react-router-dom';

// import { get_customer_order_details } from '../../store/reducers/orderReducer';
// import { get_event_details } from '../../store/reducers/eventDetailsReducer';

// import Moment from 'moment';
// import { currencyFormat } from '../CurrencyFormat';
// import GetSellerConfig from '../GetSellerConfig';

// import config from '../../config';

// // Reusable info card to reduce repetition
// const InfoCard = ({ label, children, colorDark, hidden = false }) => {
//     if (hidden) return null;
//     return (
//         <div
//             className='font-semibold text-[14px] border p-1'
//             style={{ color: colorDark, borderColor: colorDark }}
//         >
//             {label && <div className='font-normal'>{label}</div>}
//             {children}
//         </div>
//     );
// };

// const OrderDetails = () => {
//     const sellerBoolShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;

//     const { userInfo } = useSelector(state => state.auth);
//     const { myOrder } = useSelector(state => state.order);
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { seller } = useSelector(state => state.seller);

//     const {
//         sellerPrimaryColor1,
//         sellerColorSuffixDark,
//         sellerColorSuffixLight,
//         sellerProductPluralTerm,
//     } = GetSellerConfig();

//     const { orderId } = useParams();
//     const dispatch = useDispatch();

//     useEffect(() => {
//         if (userInfo?.id) {
//             dispatch(get_event_details(userInfo.id));
//         }
//     }, [userInfo?.id]);

//     useEffect(() => {
//         if (orderId) {
//             dispatch(get_customer_order_details(orderId));
//         }
//     }, [orderId]);

//     // Derived visibility flags — computed once, not as a render side-effect
//     const { showPayments, showQuantities } = useMemo(() => {
//         let showPayments = seller.isVisibleSitePayments === 'Show';
//         let showQuantities = seller.isVisibleSiteProductQuantities === 'Show';

//         const hasPackage =
//             userInfo &&
//             eventDetails &&
//             myOrder.eventDetailsInfo?.selectedSellerPackage &&
//             myOrder.eventDetailsInfo.selectedSellerPackage !== 'None';

//         if (hasPackage) {
//             showPayments = false;
//             showQuantities = false;
//         }

//         return { showPayments, showQuantities };
//     }, [
//         seller.isVisibleSitePayments,
//         seller.isVisibleSiteProductQuantities,
//         userInfo,
//         eventDetails,
//         myOrder.eventDetailsInfo?.selectedSellerPackage,
//     ]);

//     const colorDark = sellerPrimaryColor1 + sellerColorSuffixDark;
//     const colorLight = sellerPrimaryColor1 + sellerColorSuffixLight;

//     const eventInfo = myOrder.eventDetailsInfo ?? {};
//     const isEventDateValid = Moment(eventInfo.eventDate).isValid();

//     const sortedProducts = useMemo(() => {
//         return [...(myOrder.products ?? [])].sort((a, b) => {
//             if (a.category !== b.category) return a.category < b.category ? -1 : 1;
//             if (a.name !== b.name) return a.name < b.name ? -1 : 1;
//             return 0;
//         });
//     }, [myOrder.products]);

//     return (
//         <div className='rounded-md bg-white'>
//             <div
//                 className='p-3 border rounded-md'
//                 style={{
//                     backgroundColor: colorLight,
//                     color: colorDark,
//                     borderColor: colorDark,
//                 }}
//             >
//                 {/* Header */}
//                 <div
//                     className='text-lg pb-2 font-sans font-bold'
//                     style={{ color: colorDark }}
//                 >
//                     <span>Order Placed: {Moment(myOrder.date).format('MM/DD/yyyy h:mm a')}</span>
//                     <span> &nbsp;|&nbsp; Order Type: {myOrder.orderType}</span>
//                 </div>

//                 {/* Event Info Grid */}
//                 <div className='pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2'>

//                     <InfoCard label='Event Name:' colorDark={colorDark}>
//                         <div>{eventInfo.eventName}</div>
//                         <div>{eventInfo.depositGiven ? 'Deposit Given' : 'Deposit Not Given'}</div>
//                         <div className='font-normal'>Package:</div>
//                         <div>{eventInfo.selectedSellerPackage}</div>
//                     </InfoCard>

//                     <InfoCard label='Venue Name/Address:' colorDark={colorDark}>
//                         <div>{eventInfo.venueName} {eventInfo.venueAddress}</div>
//                     </InfoCard>

//                     <InfoCard colorDark={colorDark}>
//                         <div>
//                             <span className='font-normal'>Event Type: </span>
//                             {eventInfo.eventType}
//                         </div>
//                         <div>
//                             <span className='font-normal'>Guest Count: </span>
//                             {eventInfo.eventGuestCount}
//                         </div>
//                     </InfoCard>

//                     <InfoCard
//                         label='Event Date/Time:'
//                         colorDark={colorDark}
//                         hidden={!isEventDateValid}
//                     >
//                         {Moment(`${eventInfo.eventDate} ${eventInfo.eventStartTime}`).format('ddd, MM/DD/yyyy h:mm A')}
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1}>
//                         <span className='font-normal'>Service Type: </span>
//                         {eventInfo.eventServiceType}
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1}>
//                         <span className='font-normal'>Place Settings: </span>
//                         {eventInfo.eventPlaceSettings}
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1}>
//                         <div>
//                             <span className='font-normal'>Tablecloth Color: </span>
//                             {eventInfo.eventGuestTableclothColor}
//                         </div>
//                         <div>
//                             <span className='font-normal'>Napkin Color: </span>
//                             {eventInfo.eventNapkinColor}
//                         </div>
//                     </InfoCard>

//                     <InfoCard label='Manager Contact Info:' colorDark={sellerPrimaryColor1}>
//                         <div>{eventInfo.venueManagerContactInfo}</div>
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1}>
//                         <span className='font-normal'>Notes: </span>
//                         {eventInfo.eventNotes}
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1} hidden={!showPayments}>
//                         <span className='font-normal'>Order Total: </span>
//                         {currencyFormat.format(myOrder.price)}
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1} hidden={!showPayments}>
//                         <span className='font-normal'>Payment Status: </span>
//                         <span
//                             className={`p-1 text-xs px-3 rounded-md ${
//                                 myOrder.payment_status === 'paid'
//                                     ? 'bg-green-300 text-green-800'
//                                     : 'bg-red-300 text-red-800'
//                             }`}
//                         >
//                             {myOrder.payment_status}
//                         </span>
//                     </InfoCard>

//                     <InfoCard colorDark={sellerPrimaryColor1}>
//                         <span className='font-normal'>Order Status: </span>
//                         <span
//                             className={`p-1 text-xs px-3 rounded-md ${
//                                 myOrder.delivery_status === 'paid'
//                                     ? 'bg-green-300 text-green-800'
//                                     : 'bg-red-300 text-red-800'
//                             }`}
//                         >
//                             {myOrder.delivery_status}
//                         </span>
//                     </InfoCard>
//                 </div>

//                 {/* Products Section */}
//                 <div className='pt-2' style={{ color: sellerPrimaryColor1 }}>
//                     <div>
//                         <span className='text-xl font-semibold'>
//                             {sortedProducts.length} Ordered {sellerProductPluralTerm}
//                         </span>
//                         <span className='ml-2 text-md'>(Sorted By Category, Name)</span>
//                     </div>
//                 </div>

//                 <div className='pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2'>
//                     {sortedProducts.map((p) => (
//                         <div
//                             key={`${p.category}-${p.name}-${p._id ?? p.id}`}
//                             className='border'
//                             style={{ borderColor: colorDark }}
//                         >
//                             <div className='flex p-1 gap-5 justify-start items-center border'>
//                                 <div className='flex gap-2'>
//                                     {p.name !== 'Deposit' && (
//                                         <img
//                                             className='w-[65px] h-[65px] object-cover'
//                                             src={p.images[0]}
//                                             alt={p.name}
//                                         />
//                                     )}
//                                     <div className='flex flex-col justify-start items-start'>
//                                         <div className='text-sm font-semibold'>{p.name}</div>
//                                         <div className='text-md font-semibold'>{p.category}</div>

//                                         {p.byThePan && p.byThePan !== 'NoPan' && (
//                                             <div className='text-sm font-semibold'>{p.byThePan}</div>
//                                         )}

//                                         {showPayments && (
//                                             <div>
//                                                 {currencyFormat.format(
//                                                     p.price - Math.floor((p.price * p.discount) / 100)
//                                                 )}
//                                             </div>
//                                         )}

//                                         {p.name !== 'Deposit' && (
//                                             <div>
//                                                 {sellerBoolShowBrand && (
//                                                     <p><span>Brand: {p.brand}</span></p>
//                                                 )}
//                                                 {showQuantities && (
//                                                     <p><span>Quantity: {p.quantity}</span></p>
//                                                 )}
//                                                 {p.portionSize && (
//                                                     <p><span>Portion Size: {p.portionSize}</span></p>
//                                                 )}
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OrderDetails;






//my original code
// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom';

// import { get_customer_order_details } from '../../store/reducers/orderReducer';
// import { get_event_details } from '../../store/reducers/eventDetailsReducer';

// import Moment from 'moment';
// import { currencyFormat } from '../CurrencyFormat';
// import GetSellerConfig from '../GetSellerConfig';

// import config from '../../config';

// const OrderDetails = () => {
//     const sellerBoolShowBrand = config.BOOL_SHOW_PRODUCT_BRAND
    
//     const { userInfo } = useSelector(state => state.auth)
//     const { myOrder } = useSelector(state => state.order)
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { seller } = useSelector(state => state.seller)
    
//     let sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     let sellerBoolShowSiteProductQuantities = seller.isVisibleSiteProductQuantities === 'Show' ? true : false

//     // const d = new Date(myOrder.eventDetailsInfo?.eventDate);
//     // let day = d.getDay();
//     // console.log(d);
//     //     //myOrder.eventDetailsInfo?.eventDate

//     // const { cart_products, cart_product_count, successMessage, price, buy_product_item, 
//     //     shipping_fee, outofstock_products } = useSelector(state => state.cart) //outOfStockProduct

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
//     } = GetSellerConfig();

//     const {orderId} = useParams()
//     const dispatch = useDispatch()

//     useEffect(() => {
//         if (userInfo) {
//             dispatch(get_event_details(userInfo.id))
//         }
//     },[userInfo.id])
    
//     useEffect(() => {
//         dispatch(get_customer_order_details(orderId))
//     },[orderId])

//     //myOrder.eventDetailsInfo?.selectedSellerPackage
//     const setPaymentsAndQuantitiesLocal = () => {
//         if (userInfo) {
//             if (myOrder.eventDetailsInfo?.selectedSellerPackage !== undefined) {
//                 //console.log(eventDetails?.selectedSellerPackage) 
//                 if (eventDetails) {
//                     if (myOrder.eventDetailsInfo?.selectedSellerPackage !== 'None') {
//                         sellerBoolShowSitePayments = false
//                         sellerBoolShowSiteProductQuantities = false
//                     } 
//                 }
//             }
//         }
//     }

//     //console.log(myOrder?.products.length) //text-lg pb-2 font-sans font-bold
    
//     return (
//         <div className='rounded-md bg-white'>
//             <div className='p-3 border rounded-md'
//                 style={{
//                     backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight, 
//                     color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                     borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
//                 }}>
//                 {setPaymentsAndQuantitiesLocal()}
//                 <div className='text-lg pb-2 font-sans font-bold' 
//                     style={{color:sellerPrimaryColor1 + sellerColorSuffixDark}}>
//                     <span>Order Placed: {Moment(myOrder.date).format('MM/DD/yyyy h:mm a')}</span>
//                     <span> Order Type: {myOrder.orderType}</span>
//                 </div>
//                 <div className='pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2'>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{
//                             color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                             borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
//                         }}>
//                         <div className='font-normal'>Event Name: </div>
//                         <div>{myOrder.eventDetailsInfo?.eventName}</div>
//                         {
//                             myOrder.eventDetailsInfo?.depositGiven ? 'Deposit Given' : 'Deposit Not Given'
//                         }
//                         <div className='font-normal'>Package:</div>
//                         {
//                             myOrder.eventDetailsInfo?.selectedSellerPackage
//                         }
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{
//                             color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                             borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
//                         }}>
//                         <div>
//                             <label className='font-normal'>Venue Name/Address:</label>
//                         </div>
//                         <div>
//                             {myOrder.eventDetailsInfo?.venueName} {myOrder.eventDetailsInfo?.venueAddress}
//                         </div>
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{
//                             color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                             borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
//                         }}>
//                         <div>
//                             <label className='font-normal'>Event Type: </label>
//                             {myOrder.eventDetailsInfo?.eventType}
//                         </div>
//                         <div>
//                             <label className='font-normal'>Guest Count: </label>
//                             {myOrder.eventDetailsInfo?.eventGuestCount}
//                         </div>
//                     </div>
//                     <div className={` ${Moment(myOrder.eventDetailsInfo?.eventDate).isValid() ? '' : 'hidden'} 
//                         font-semibold text-[14px] border p-1`}  
//                         style={{
//                             color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                             borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
//                         }}>
//                         <div className='font-normal'>Event Date/Time:</div>
//                         {Moment(myOrder.eventDetailsInfo?.eventDate + ' ' + myOrder.eventDetailsInfo?.eventStartTime).format('ddd, MM/DD/yyyy h:mm A')}
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <label className='font-normal'>Service Type: </label>
//                         {myOrder.eventDetailsInfo?.eventServiceType}
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <label className='font-normal'>Place Settings: </label>
//                         {myOrder.eventDetailsInfo?.eventPlaceSettings}
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <div>
//                             <label className='font-normal'>Tablecloth Color: </label>
//                             {myOrder.eventDetailsInfo?.eventGuestTableclothColor}
//                         </div>
//                         <div>
//                             <label className='font-normal'>Napkin Color: </label>
//                             {myOrder.eventDetailsInfo?.eventNapkinColor}
//                         </div>
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <div>
//                             <label className='font-normal'>Manager Contact Info: </label>
//                         </div>
//                         <div>
//                             {myOrder.eventDetailsInfo?.venueManagerContactInfo}
//                         </div>
//                     </div>
//                     <div className='font-semibold text-[14px] border p-1' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <label className='font-normal'>Notes: </label>
//                         {myOrder.eventDetailsInfo?.eventNotes}
//                     </div>
//                     <div className={`${sellerBoolShowSitePayments ? '' : 'hidden'} font-semibold text-[14px] border p-2`} 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <label className='font-normal'>Order Total: </label>
//                         {currencyFormat.format(myOrder.price)}
//                     </div>
//                     <div className={`${sellerBoolShowSitePayments ? '' : 'hidden'} font-semibold text-[14px] border p-2`} 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <label className='font-normal'>Payment Status: </label>
//                         <span className={`p-1 text-xs px-3 
//                             ${myOrder.payment_status === 'paid' ? 'bg-green-300 text-green-800' 
//                             : 'bg-red-300 text-red-800' } rounded-md`}> 
//                             {myOrder.payment_status} 
//                         </span>
//                     </div>
//                     <div className={`font-semibold text-[14px] border p-2`} 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <label className='font-normal'>Order Status: </label>
//                         <span className={`p-1 text-xs px-3 
//                             ${myOrder.delivery_status === 'paid' ? 'bg-green-300 text-green-800' 
//                             : 'bg-red-300 text-red-800' } rounded-md`}>
//                             {myOrder.delivery_status}
//                         </span>
//                     </div>
//                 </div>
//                 <div className='pt-2' style={{color:sellerPrimaryColor1}}>
//                     {
//                         // <div className='' style={{color:sellerPrimaryColor1}}>
//                         // <span className='text-xl font-semibold'>{buy_product_item} {sellerProductPluralTerm}, {sellerCompanyName}</span>
//                         // <span className='ml-2 text-md' >(Sorted By Category, Name)</span>
//                         // </div>
//                         //text-lg pb-2 font-sans font-bold
//                     }
//                     <div className='' style={{color:sellerPrimaryColor1}}>
//                         <span className='text-xl font-semibold' >{myOrder?.products?.length} Ordered {sellerProductPluralTerm}</span>
//                         <span className='ml-2 text-md' >(Sorted By Category, Name)</span>
//                     </div>
//                 </div>
            
//                 <div className='pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2'>
//                 {
//                     myOrder.products?.toSorted((a, b) => {
//                         if (a?.category === b?.category) {
//                             if (a?.name === b?.name) {
//                                 return 0
//                             }
//                             if (a?.name < b?.name) {
//                                 return -1
//                             }
//                             return 1
//                         }
//                         if (a.category < b?.category) {
//                             return -1
//                         }
//                         return 1
//                     }).map((p,i) => 
//                         <div key={i} className='border' 
//                             style={{borderColor:sellerPrimaryColor1 + sellerColorSuffixDark}}>
//                             <div className='flex p-1 gap-5 justify-start items-center border'>
//                                 <div className='flex gap-2'>
//                                     <img className={` ${p.name === 'Deposit' ? 'hidden' : ''} w-[65px] h-[65px]`} src={p.images[0]} alt="" />
//                                     <div className='flex flex-col justify-start items-start'>
//                                         <div className='text-sm font-semibold'>{p.name}</div>
//                                         <div className='text-md font-semibold'>{p.category}</div>
//                                         <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''} text-sm font-semibold`}>
//                                             {p.byThePan}
//                                         </div>
//                                         <div className={`${sellerBoolShowSitePayments ? '' : 'hidden'}`}>
//                                             {currencyFormat.format(p.price - Math.floor((p.price * p.discount) / 100))}
//                                         </div>
//                                         <div className={`${p.name === 'Deposit' ? 'hidden' : ''}`} >
//                                             <p className={`${sellerBoolShowBrand ? '' : 'hidden'}`}>
//                                                 <span>Brand:{p.brand}</span>
//                                             </p>
//                                             <p className={`${sellerBoolShowSiteProductQuantities ? '' : 'hidden'}`}>
//                                                 <span>Quantity : {p.quantity}</span>
//                                             </p>
//                                             <p className={`${p.portionSize !== '' ? '' : 'hidden'}`}>
//                                                 <span>Portion Size : {p.portionSize}</span>
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className='pl-4 flex flex-col border'>
//                                     <p className='hidden line-through'>{p.price}</p>
//                                     <p className='hidden'>-{p.discount}%</p>
//                                 </div>
//                             </div>
//                         </div>
//                     )
//                 }
//             </div>
//         </div>   
//     </div>
//     );
// };

// export default OrderDetails;





